import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    CONNECTION_ERROR: {
        id: 'ase.maintenanceTicket.issueIdentified.connectionError',
        defaultMessage: 'Connection error'
    },
    MISSING_INFORMATION: {
        id: 'ase.maintenanceTicket.issueIdentified.missingInformation',
        defaultMessage: 'Missing information in one or many field'
    },
    DUE_DATE_NOT_UNDERSTOOD: {
        id: 'ase.maintenanceTicket.issueIdentified.dueDateNotUnderstood',
        defaultMessage: 'Due date not understood'
    },
    MISSING_MILEAGE_OVER_6_MONTHS: {
        id: 'ase.maintenanceTicket.issueIdentified.missingMileageOverSixMonths',
        defaultMessage: 'Missing mileage for an operation performed more than 6 month ago'
    },
    OPERATION_ALREADY_REALIZED: {
        id: 'ase.maintenanceTicket.issueIdentified.operationAlreadyRealized',
        defaultMessage: 'Operation considered to be performed when already realised'
    },
    MISSING_OPERATION_IN_PROGRAM: {
        id: 'ase.maintenanceTicket.issueIdentified.missingOperationInProgram',
        defaultMessage: 'Missing operation in maintenance program'
    },
    ADDITIONAL_OPERATION_NOT_PLANNED: {
        id: 'ase.maintenanceTicket.issueIdentified.additionalOperationNotPlanned',
        defaultMessage: 'Additionnal operation in maintenance program but not planned'
    }
});

export default messages;
